import React from 'react'
export const POSTS = [{
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
    width: 50,
    render: date => {
        var str = date.split("-");
        var fYear = str[0],
            fMonth = str[1],
            fDay = str[2];

        return fDay + "-" + fMonth + "-" + fYear;
    }
}, {
    title: 'Time',
    dataIndex: 'time',
    key: 'time',
    width: 50,
    className: 'hideThis'
}, {
    title: 'Job',
    dataIndex: 'job',
    key: 'job',
    width: 150
}, {
    title: 'Activity',
    dataIndex: 'activity',
    key: 'activity',
    width: 150
}, {
    title: 'Posted by',
    dataIndex: 'poster',
    key: 'poster',
    width: 50,
    className: 'hideThis'
}];

export const ENQUIRY = (viewEnquiry) => {
    return (
        [{
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
            render: date => {
                var str = date.split("-");
                var fYear = str[0],
                    fMonth = str[1],
                    fDay = str[2];

                return fDay + "-" + fMonth + "-" + fYear;
            },
            sorter: (a, b) => new Date(a.date) - new Date(b.date),
            defaultSortOrder: 'descend',
        }, {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        }, {
            title: 'Phone',
            dataIndex: 'phone',
            key: 'phone',
        }, {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            className: 'hideThis'
        }, {
            title: 'Address',
            dataIndex: 'address',
            key: 'address',
            className: 'hideThis'
        }, {
            title: 'Bore Type',
            dataIndex: 'boreType',
            key: 'type',
        }, {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => {
                return (
                    <span style={{ color: '#40a9ff', cursor: 'pointer' }} href='#' onClick={() => viewEnquiry(record)}>View</span>
                )
            }
        }]
    )
};